import IPORegister from'./IPORegister';export default IPORegister;